angular.module('ikeweb.locale').factory('localeService', [
    'functional',
    'localStorageService',
    'loginService',
    'pubSubService',
    'localeTopics',
    'loginTopics',
    'localeConstants',
    'translationService',
    'promiseFactory',
    function(f,
        localStorageService,
        loginService,
        pubSubService,
        localeTopics,
        loginTopics,
        LOCALES,
        translationService,
        promiseFactory) {

        var LOCALE_LOCAL_STORAGE_KEY = 'locale.current';
        var DEFAULT_LOCALE = 'en-US';

        function getAvailableLocales() {
            return LOCALES;
        }

        function gerUserLocale() {
            var user = loginService.getLoggedInUser();
            return user && user.getLocale();
        }

        function setUserLocale(locale) {
            var user = loginService.getLoggedInUser();
            return user ?
                loginService.save(user.setLocale(locale)) :
                promiseFactory.resolvedPromise();
        }

        function gerLocaleStorageLocale() {
            return localStorageService.get(LOCALE_LOCAL_STORAGE_KEY);
        }

        function setLocaleStorageLocale(locale) {
            localStorageService.set(LOCALE_LOCAL_STORAGE_KEY, locale);
        }

        var containsRight = f.curryRight(f.contains);

        var lessSpecific = f.comparator(function(locale, otherLocale) {
            return locale.value.length < otherLocale.value.length;
        });

        function getLanguageFromLocale(locale) {
            return locale.split('-')[0];
        }

        function findLocale(locales, locale) {
            return locale && f.find(locales, f.propIs('value', f.equal(locale)));
        }

        function findFallbackLocale(locales, locale) {
            return locale && f.find(f.sort(locales, lessSpecific), f.propIs('value', containsRight(getLanguageFromLocale(locale))));
        }

        function getCurrentLocale() {
            var locales = getAvailableLocales();
            var locale = gerUserLocale() || gerLocaleStorageLocale();

            return findLocale(locales, locale) ||
                findFallbackLocale(locales, locale) ||
                findLocale(locales, DEFAULT_LOCALE);
        }

        function publishLocaleChange() {
            pubSubService.publish(localeTopics.LOCALE.CHANGED);
        }

        function translate() {
            return translationService.translate(getCurrentLocale().value);
        }

        function setCurrentLocale(locale) {
            return setUserLocale(locale)
                .then(setLocaleStorageLocale.bind(null, locale))
                .then(translate)
                .then(publishLocaleChange);
        }

        pubSubService.subscribe(loginTopics.LOGIN.COMPLETED.SUCCESS, translate);

        return {
            getAvailableLocales: getAvailableLocales,
            getCurrentLocale: getCurrentLocale,
            setCurrentLocale: setCurrentLocale
        };
    }
]);



//////////////////
// WEBPACK FOOTER
// ./src/client/components/locale/locale.service.js
// module id = 479
// module chunks = 0